import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EntityStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'stateStatusDisplay',
  pure: true,
})
export class StateStatusDisplayPipe implements PipeTransform {
  transform(value: EntityStatus): string {
    return CoreNiceLabelUtils.stateStatus(value);
  }
}
export function stateStatusDisplayTransform(value: EntityStatus) {
  return CoreNiceLabelUtils.stateStatus(value);
}
